<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-if="$route.params.id !== undefined"
          variant="success"
          :to="{ name: 'users-add' }"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> {{ $t('Add New') }}
          </span>
        </b-button>
        <span v-else />
      </template>
    </app-breadcrumb>
    <b-row>
      <b-col
        md="6"
        offset-md="3"
      >
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-card>
            <b-alert
              variant="primary"
              :show="errorMessage.length"
            >
              <div class="alert-body">
                {{ errorMessage }}
              </div>
            </b-alert>
            <!-- BODY -->
            <validation-observer
              #default="{ handleSubmit }"
              ref="refFormObserver"
            >
              <!-- Form -->
              <b-form
                class=""
                autocomplete="off"
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >

                <!-- Full Name -->
                <validation-provider
                  #default="validationContext"
                  name="full_name"
                  rules="required|max:30"
                >
                  <b-form-group label-for="full-name">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Full Name') }} <span class="text-danger">*</span></label>
                    </template>
                    <b-form-input
                      id="full-name"
                      v-model="userData.full_name"
                      autofocus
                      :state="getValidationState(validationContext)"
                      placeholder="Nguyễn Văn A"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Username -->
                <validation-provider
                  #default="validationContext"
                  name="username"
                  rules="required|alpha-num|min:4|unique-user"
                >
                  <b-form-group label-for="new-username">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('auth.username') }} <span class="text-danger">*</span></label>
                      <p>{{ $t('auth.username') }} dùng để đăng nhập</p>
                    </template>
                    <b-form-input
                      id="new-username"
                      v-model="userData.username"
                      name="new-username"
                      :state="getValidationState(validationContext)"
                      autocomplete="new-user"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Email -->
                <validation-provider
                  #default="validationContext"
                  name="Email"
                  rules="required|email|max:150"
                >
                  <b-form-group label-for="email">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Email') }} <span class="text-danger">*</span></label>
                      <p>Email có thể dùng để đăng nhập</p>
                    </template>
                    <b-form-input
                      id="email"
                      v-model="userData.email"
                      v-mask="{ alias: 'email' }"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- password -->
                <b-form-group>
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ $t('Password') }} <span class="text-danger">*</span></label>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="password"
                    rules="required|min:6|max:50"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <b-form-input
                        id="new-password"
                        v-model="userData.password"
                        class="form-control-merge"
                        type="password"
                        :state="errors.length > 0 ? false : null"
                        name="new-password"
                        :placeholder="$t('auth.password')"
                        autocomplete="new-pass"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- confirm password -->
                <b-form-group>
                  <template #label>
                    <label class="d-block font-weight-bolder">{{ $t('auth.confirm_password') }} <span class="text-danger">*</span></label>
                  </template>
                  <validation-provider
                    #default="{ errors }"
                    name="confirm_password"
                    rules="required|confirmed:password"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid' : null"
                    >
                      <template #label>
                        <label class="d-block font-weight-bolder">{{ $t('auth.confirm_password') }} <span class="text-danger">*</span></label>
                      </template>
                      <b-form-input
                        id="new-confirm-password"
                        v-model="userData.confirm_password"
                        type="password"
                        class="form-control-merge"
                        :state="errors.length > 0 ? false : null"
                        name="new-confirm-password"
                        :placeholder="$t('auth.confirm_password')"
                        autocomplete="new-confirm-pass"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Phone -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Phone')"
                  rules="required|max:12"
                >
                  <b-form-group label-for="phone">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Phone') }} <span class="text-danger">*</span></label>
                      <p>{{ $t('Phone') }} có thể dùng để đăng nhập</p>
                    </template>
                    <b-form-input
                      id="phone"
                      v-model="userData.phone"
                      v-mask="{ mask: '0999999999[9]', greedy: true }"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Birthday -->
                <validation-provider
                  #default="validationContext"
                  name="birthday"
                  rules="max:10"
                >
                  <b-form-group label-for="birthday">
                    <template #label>
                      <label class="d-block font-weight-bolder">Ngày sinh</label>
                    </template>
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="birthday"
                        v-model="userData.birthday"
                        v-mask="{ mask: '99/99/9999', greedy: true }"
                        :state="getValidationState(validationContext)"
                      />
                      <b-input-group-append is-text>
                        <feather-icon icon="CalendarIcon" />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Alias -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Alias')"
                  rules="required|max:100"
                >
                  <b-form-group
                    :label="$t('Alias')"
                    label-for="alias"
                  >
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Alias') }} <span class="text-danger">*</span></label>
                    </template>
                    <b-form-input
                      id="alias"
                      v-model="userData.alias"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Timezone -->
                <!-- <validation-provider
                  #default="validationContext"
                  :name="$t('Time zone')"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Time zone') }} <span class="text-danger">*</span></label>
                    </template>
                    <v-select
                      v-model="userData.timezone"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="timezones"
                      :reduce="(val) => val.value"
                      label="label"
                      input-id="user-timezone"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider> -->

                <!-- Gender -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Gender')"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Gender') }} <span class="text-danger">*</span></label>
                    </template>
                    <v-select
                      v-model="userData.gender"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="genderOptions"
                      :reduce="(val) => val.id"
                      input-id="gender"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Position -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Position')"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Position') }} <span class="text-danger">*</span></label>
                    </template>
                    <v-select
                      v-model="userData.position_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="positionOptions"
                      :reduce="(val) => val.id"
                      label="name"
                      input-id="user-roles"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Department -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Department')"
                  rules="required"
                >

                  <b-form-group :state="getValidationState(validationContext)">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Department') }} <span class="text-danger">*</span></label>
                    </template>
                    <!-- <v-select
                      v-model="userData.department_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="departmentOptions"
                      :reduce="(val) => val.id"
                      label="name"
                      input-id="user-departments"
                    /> -->
                    <treeselect
                      v-model="userData.department_id"
                      :multiple="false"
                      :options="departmentOptions"
                      :disable-branch-nodes="false"
                      :default-expand-level="5"
                      search-nested
                      :clearable="true"
                      no-results-text="Không tìm thấy kết quả"
                      no-options-text="Không có lựa chọn nào"
                      placeholder="Chọn phòng"
                      loading-text="Đang tải"
                      search-prompt-text="Nhập tên"
                      :normalizer="normalizerTreeList"
                      :always-open="false"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- User Role -->
                <validation-provider
                  #default="validationContext"
                  :name="$t('Role')"
                  rules="required"
                >
                  <b-form-group :state="getValidationState(validationContext)">
                    <template #label>
                      <label class="d-block font-weight-bolder">{{ $t('Role') }} <span class="text-danger">*</span></label>
                    </template>
                    <v-select
                      v-model="userData.roles"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="roleOptions"
                      :reduce="(val) => val.id"
                      label="display_name"
                      :clearable="true"
                      input-id="user-roles"
                      :multiple="true"
                    />
                    <b-form-invalid-feedback :state="getValidationState(validationContext)">
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- File Storage Quota -->
                <validation-provider
                  #default="validationContext"
                  name="Giới hạn dung lượng lưu trữ file"
                  rules="required|number-min-zero"
                >
                  <b-form-group
                    label="Giới hạn dung lượng lưu trữ file"
                    label-for="file_storage_quota"
                  >
                    <template #label>
                      <label class="d-block font-weight-bolder">Giới hạn dung lượng lưu trữ file (MB). Đặt bằng 0 để không giới hạn.<span class="text-danger">*</span></label>
                    </template>
                    <b-form-input
                      id="file_storage_quota"
                      v-model="userData.file_storage_quota"
                      type="number"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <!-- Form Actions -->
                <div class="d-flex mt-2">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="secondary"
                    class="mr-2"
                    :to="{ name: 'users-list' }"
                  >
                    {{ $t('Back') }}
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    class="mr-2"
                    type="submit"
                  >
                    {{ $t('Add') }}
                  </b-button>
                </div>

              </b-form>
            </validation-observer>
          </b-card>
        </b-overlay>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BOverlay,
  BCol, BCard, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
  BInputGroupAppend,
  BInputGroup,
  BAlert,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { ref } from '@vue/composition-api'
import {
  required, alphaNum, email, min, max, numberMinZero,
} from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import router from '@/router'
import store from '@/store'
import { showToast } from '@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import axiosIns from '@axios';
import _ from 'lodash'
// import flatPickr from 'vue-flatpickr-component'
import { timezones } from '@/libs/constants'
import Treeselect from '@riophae/vue-treeselect'
import useUsers from './useUsers'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import useDepartments from '../department/useDepartments'

export default {
  components: {
    AppBreadcrumb,
    BRow,
    BCol,
    BCard,
    BForm,
    BOverlay,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BInputGroupAppend,
    BInputGroup,
    BAlert,
    vSelect,
    Treeselect,
    // flatPickr,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {

  },
  data() {
    return {
      required,
      alphaNum,
      email,
      min,
      max,
      numberMinZero,
      timezones,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  setup() {
    const errorMessage = ref('')
    const positionOptions = ref([])
    const roleOptions = ref([])
    const blankUserData = {
      full_name: '',
      username: '',
      email: '',
      roles: null,
      gender: '',
      phone: '',
      birthday: '',
      alias: '',
      timezone: 'Asia/Ho_Chi_Minh',
      password: '',
      confirm_password: '',
      department_id: null,
      position_id: null,
      file_storage_quota: 0,
    }

    const userData = ref(JSON.parse(JSON.stringify(blankUserData)))
    const resetuserData = () => {
      userData.value = JSON.parse(JSON.stringify(blankUserData))
    }

    const {
      loading,
      statusOptions,
      genderOptions,
      fetchDepartmentTrees,
      departmentOptions,
    } = useUsers();

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    const {
      normalizerTreeList,
    } = useDepartments();

    const onSubmit = () => {
      store.dispatch('users/addUser', userData.value)
        .then((response) => {
          // console.log('response', response);
          if (response.status === 200) {
            if (response.data.code === 200) {
              resetForm();
              errorMessage.value = '';
              showToast(response.data.message, { variant: 'success' })
              router.push({ name: 'users-list' })
            } else {
              showToast(response.data.message)
              errorMessage.value = response.data.message
            }
          }
        })
    }

    const checkExistUser = () => {
      store.dispatch('users/fetchPositions')
        .then(response => {
          if (response.status === 200) {
            positionOptions.value = response.data.data
          }
        })
    }

    const isUnique = async (value) => {
      const res = await axiosIns.get('/users/search', { params: { keyword: value, exactly: 1 } });
      return {
        valid: res.status === 200 && !res.data.data.length,
        // data: {
        //   message: !res.data.data ? '' : 'Tên người dùng đã tồn tại',
        // },
      };
    };

    extend('unique-user', {
      validate: _.debounce((val) => isUnique(val), 300),
      message: 'Tên người dùng đã tồn tại',
      // getMessage: (field, params, data) => data.message,
    });

    store.dispatch('users/fetchPositions')
      .then(response => {
        if (response.status === 200) {
          positionOptions.value = response.data.data
        }
      })

    // store.dispatch('users/fetchDepartments')
    //   .then(response => {
    //     if (response.status === 200) {
    //       const items = response.data.data;
    //       items.forEach((root) => {
    //         const item = {
    //           id: root.id,
    //           label: root.name,
    //           children: [],
    //         };
    //         if (root.childrens.length) {
    //           root.childrens.forEach((c1) => {
    //             const item1 = {
    //               id: c1.id,
    //               label: c1.name,
    //               children: [],
    //             }
    //             if (c1.childrens.length) {
    //               c1.childrens.forEach((c2) => {
    //                 const item2 = {
    //                   id: c2.id,
    //                   label: c2.name,
    //                   children: [],
    //                 }
    //                 if (c2.childrens.length) {
    //                   c2.childrens.forEach((c3) => {
    //                     const item3 = {
    //                       id: c3.id,
    //                       label: c3.name,
    //                       children: [],
    //                     }
    //                     if (c3.childrens.length) {
    //                       c3.childrens.forEach((c4) => {
    //                         const item4 = {
    //                           id: c4.id,
    //                           label: c4.name,
    //                           children: [],
    //                         }
    //                         if (c4.childrens.length) {
    //                           c4.childrens.forEach((c5) => {
    //                             const item5 = {
    //                               id: c5.id,
    //                               label: c5.name,
    //                               children: [],
    //                             }
    //                             item4.children.push(item5);
    //                           })
    //                         }
    //                         item3.children.push(item4);
    //                       })
    //                     }
    //                     item2.children.push(item3);
    //                   })
    //                 }
    //                 item1.children.push(item2);
    //               })
    //             }
    //             item.children.push(item1);
    //           })
    //         }
    //         departmentOptions.value.push(item);
    //       });
    //     }
    //   })

    store.dispatch('users/fetchRoles')
      .then(response => {
        if (response.status === 200) {
          roleOptions.value = response.data.data
        }
      })

    fetchDepartmentTrees();

    return {
      loading,
      errorMessage,
      userData,
      roleOptions,
      departmentOptions,
      positionOptions,
      onSubmit,
      checkExistUser,
      refFormObserver,
      getValidationState,
      resetForm,
      statusOptions,
      genderOptions,
      normalizerTreeList,
      fetchDepartmentTrees,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/base/components/treeselectlist.scss';
</style>
